module.exports = __webpack_public_path__ + "static/media/ItalicBlack.e7de23e7.svg";